import { int } from "@goodgamestudios/math-utilities";
import { Poker2LobbyDataEvent } from "../../event/Poker2LobbyDataEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { BasicData } from "./BasicData";

import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("Poker2LobbyData");

export class Poker2LobbyData extends BasicData {
    public lobbyTables: LobbyTablesVO[];

    constructor() {
        super();
    }
    /*
    *		GET_TLI : Table List
    */
    public parse_TLI(paramObject: any): void {
        this.parseTableList(paramObject.L);
    }

    private parseTableList(paramArray: any[]): void {
        this.lobbyTables = [];
        var counter: number = 0;
        if (paramArray)
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var lobbyTablesVO: LobbyTablesVO = new LobbyTablesVO();
                    lobbyTablesVO.id = tableLine.shift();
                    lobbyTablesVO.name = tableLine.shift();
                    lobbyTablesVO.sBlind = int(tableLine.shift());
                    lobbyTablesVO.players = int(tableLine.shift());
                    lobbyTablesVO.specs = int(tableLine.shift());
                    lobbyTablesVO.pot = tableLine.shift();
                    lobbyTablesVO.xpEarnStatus = int(tableLine.shift());
                    lobbyTablesVO.counter = counter;
                    this.lobbyTables.push(lobbyTablesVO);
                    counter++;
                }
            }
        this.controller.dispatchEvent(new Poker2LobbyDataEvent("changeLobbyTableData"));
    }

    public getLobbyTableById(id: number): LobbyTablesVO {
        if (this.lobbyTables != null) {
            for (let entryList of this.lobbyTables) {
                var lobbyTable: any = entryList;
                if (lobbyTable === undefined) continue;

                if (lobbyTable.id == id)
                    return lobbyTable;
            }
        }
        logger.error(`Can't find LobbyTablesVO for id: ${id}, current lobbgyTableList has ${this.lobbyTables ? this.lobbyTables.length : 'null'} elements.`);
        return null;
    }

}
